import request from '@/utils/request';


export function getArtcle(id) {
    return request({
      url: '/wx/article/detail',
      method: 'get',
      params: { id }
    })
  }


// WEBPACK FOOTER //
// ./src/api/article/article.js